<template>
    <div>
        <b-row class="m-0">
            <b-col md="12" class="p-0">
                <vue-dropzone
                    :options="dropzoneOptions"
                    :include-styling="true"
                    v-on:vdropzone-thumbnail="thumbnail"
                    id="customdropzone"
                    ref="customdropzone"
                    @vdropzone-complete="fileComplete"
                    @vdropzone-duplicate="fileDuplicate"
                    :duplicateCheck="true" />
            </b-col>
            <b-col md="12" class="p-0">
                <div>
                    <b-container fluid class="p-2 bg-dark">
                        <div class="gallery">
                            <div class="gallery-panel" 
                                v-for="img in images"
                                :key="img._id">
                                <div @click="selectImage(img)">
                                    <b-img-lazy                             
                                        thumbnail
                                        fluid
                                        :src="img.thumbNail"
                                        :alt="img.thumbNail" />
                                </div>
                                <div>
                                    <b-button variant="link" size="sm" borderless @click="onDeleteMedia(img)"
                                                v-b-tooltip.hover title="Delete">
                                        <b-icon icon="trash-fill" variant="danger"></b-icon>
                                    </b-button>
                                    <!-- <b-button variant="link" size="sm" borderless @click="onViewMedia(user)"
                                                v-b-tooltip.hover title="View">
                                        <b-icon icon="eye-fill" variant="primary"></b-icon>
                                    </b-button> -->
                                    <b-button variant="link" size="sm" borderless @click="onEditMedia(img)"
                                                v-b-tooltip.hover title="Edit">
                                        <b-icon icon="pencil-square" variant="info"></b-icon>
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </b-container>
                    <div class="mt-2 text-center">
                        <b-button variant="primary" size="sm" @click="fetchGallery" v-if="!isLoading && request.next"> Show More </b-button>
                    </div>
                </div>
            </b-col>
        </b-row>        
        <b-modal size="xl" id="imageCropper" title="Image Edit" hide-footer no-close-on-backdrop no-close-on-esc>
            <image-cropper 
                    :autoScaleThumb="autoScaleThumb"
                    :isCropping="isCropping"
                    :media="editingMedia"
                    @onCropData="onCropData"/>
        </b-modal>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Swal from 'sweetalert2'
import ImageCropper from '@/components/portal/ImageCropper';
//eslint-disable-next-line
function dataURItoBlob(dataURI) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  var byteString = atob(dataURI.split(',')[1]);
  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length);
  // create a view into the buffer
  var ia = new Uint8Array(ab);
  // set the bytes of the buffer to the correct values
  for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
  }
  // write the ArrayBuffer to a blob, and you're done
  //var blob = new Blob([ab], {type: mimeString});
  return { ab:ab, type: mimeString };
}

export default {
    props : {
        fileChooser : { type : Boolean, default : false }
    },
    computed: { 
        ...mapState({
            store: 'store',
            userInfo: 'userInfo',
            selectedLocation:'selectedLocation'
        })
    },
    watch:{
        selectedLocation: {
            deep: true,
            immediate: true,
            handler(){
                this.request = { next : true , limit: undefined}
                this.fetchGallery();      
            }
        }
    },    
    data() {
        let apiPath = "api/media/upload-menu"
        return {
            autoScaleThumb : "",
            isLoading:false,
            isCropping:false,
            images:[],
            request:{ next : true , limit: undefined},
            editingMedia:null,
            dropzoneOptions: {
                url: apiPath ,
                thumbnailWidth: 200,
                addRemoveLinks: true,
                autoQueue: true,
                accept: function(file, done) {
                    if (!file.type.startsWith("image")) {
                        done("Error! Files of this type are not accepted");
                    }
                    else { done(); }
                }
            }
        }
    },
    components: {
        vueDropzone: vue2Dropzone,ImageCropper       
    },
    mounted() {
        this.fetchGallery();
    },
    methods:{    
        //eslint-disable-next-line
        fileAdded(file) {
            let formData = new FormData();
            formData.append('file', file);
            this.$store.dispatch('apiMediaUpload', formData)
                    .then(({status, res, error}) => {
                        if(status) {
                            this.images.unshift(res);          
                            this.fileComplete(file)   
                        } else {
                            console.log(error)
                        }
                    }).catch(e=>{
                        console.log("apiMediaUpload-E", e)                        
                    })               
            /*
            const reader = new FileReader();
            reader.onload =  () => {
               let result = dataURItoBlob(reader.result);
               if(result.type.startsWith("image1")) {
                
            };
            if (file) {
                reader.readAsDataURL(file);
            }     */       
        },
        fileComplete(file) {
            let {status, response, responseText} = file.xhr;
            if(status === 200) {
                let json = JSON.parse(response);
                this.images.unshift(json); 
            } else {
                Swal.fire({ icon: 'error', html: responseText })
            }
            this.$refs.customdropzone.removeFile(file);
        },
        fileDuplicate(){
            this.toast(this, { msg: `Duplicate Image found` })
        },
        template: function () {
            return `<div class="dz-preview dz-file-preview">
                    <div class="dz-image">
                        <div data-dz-thumbnail-bg></div>
                    </div>
                    <div class="dz-details">
                        <div class="dz-size"><span data-dz-size></span></div>
                        <div class="dz-filename"><span data-dz-name></span></div>
                    </div>
                    <!--<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>-->
                    <div class="dz-error-message"><span data-dz-errormessage></span></div>
                    <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                    <div class="dz-error-mark"><i class="fa fa-close"></i></div>
                    </div>
            `;
        },
        thumbnail: function(file, dataUrl) {
            var j, len, ref, thumbnailElement;
            if (file.previewElement) {
                file.previewElement.classList.remove("dz-file-preview");
                ref = file.previewElement.querySelectorAll("[data-dz-thumbnail-bg]");
                for (j = 0, len = ref.length; j < len; j++) {
                    thumbnailElement = ref[j];
                    thumbnailElement.alt = file.name;
                    thumbnailElement.style.backgroundImage = 'url("' + dataUrl + '")';
                }
                return setTimeout(((function() {
                    return function() {
                        return file.previewElement.classList.add("dz-image-preview");
                    };
                })(this)), 1);
            }
        },
        fetchGallery() {
            this.isLoading = true;
            this.$store.dispatch("apiMediaGallery", this.request)
                       .then(({status, res, error}) => {
                            this.isLoading = false;                           
                            if(status) {
                                this.request.next = res.next;
                                this.request.page = res.page + 1;
                                this.autoScaleThumb = res.autoScaleThumb;
                                if(res.page === 1){
                                    this.images = [];
                                }
                                this.images = [...this.images, ...res.images]
                            } else {
                                console.log(error)
                            }
                       }).catch(e=>{
                            this.isLoading = false;                           
                            console.log("apiMediaGallery-E", e)                        
                       })
        },
        onDeleteMedia(media){
            Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.onSubmitDeleteMedia(media)
                    }
                })
        },
        onSubmitDeleteMedia(media) {
            this.$store.dispatch("apiMediaDelete", media)
                       .then(({status, error}) => {
                            if(status){
                                let index = this.images.findIndex(({_id})=> _id === media._id);
                                if (index > -1) {
                                    this.images.splice(index, 1);
                                    this.toast(this, { msg: `Image has been deleted.`, variant : "success" })
                                }
                            } else {
                                Swal.fire({ text: error, icon: 'error' })
                            }
                       }).catch(e => {
                           Swal.fire({ html: e.msgError, icon: 'error' })
                       })
        },
        onEditMedia(media){
            this.editingMedia = media;
            this.$bvModal.show("imageCropper");
        },
        onCropData(media) {
            this.isCropping = true;
            this.$store
                .dispatch("apiMediaSetClip", media)
                 .then(({status, res, error}) => {
                     this.isCropping = false;
                     if(status) {
                         let index = this.images.findIndex(({_id})=> _id === media._id);
                        if (index > -1) {
                            this.images[index] = res
                        }
                        this.$bvModal.hide("imageCropper");
                     } else {
                        console.log("apiMediaSetClip-E", error)                         
                     }
                 }).catch(e => {
                     this.isCropping = false;
                     console.log("apiMediaSetClip-E", e) 
                 });
        },
        selectImage(media) {            
            this.$emit("onSelectImage", media);
        }
    }
}
</script>

<style>
  .gallery {
    display: grid;
    /* grid-template-columns: repeat(auto-fill, minmax(10rem, 1fr)); */
    grid-template-columns: repeat(auto-fill, minmax(130px, 2fr));
    /* grid-template-rows: 50px 5em min-content auto; */
    grid-gap: 0.5rem;
    /* max-width: 80rem; */
    margin: auto auto;
    padding: 0 0rem;
  }

   /* @media (max-width: 576px) { 
       .gallery {
           grid-template-columns: repeat(auto-fill, auto-fill);
       }
    } */

  .gallery-panel img {
    width: 100%;
    height: 15vmax;
    object-fit: contain;
    border-radius: 0.2rem;
  }
</style>